import "modules/AppointmentDetails/components/Interventions/components/Subitems/Subitems.scss";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";
import SubitemsTable from "modules/HoldingAppointmentDetails/components/Interventions/components/Subitems/components/SubitemsTable";

import type { Intervention } from "models";

type SubitemsProps = {
  intervention: Intervention;
};

export const Subitems = ({ intervention }: SubitemsProps) => {
  const appointmentLocation = useAppointmentLocation();

  return (
    <div className="Subitems">
      {intervention.elements && intervention.elements.length > 0 && <SubitemsTable elements={intervention.elements} location={appointmentLocation} />}
    </div>
  );
};
